import React, { useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { useFieldArray } from 'react-hook-form'
import { useToasts } from 'react-toast-notifications'
// import InputField from '_components/Input'
import uploadApi from '_api/upload'
import { useModal } from '_hooks/useModal'
import { DEFAULT_SUB_ITEM, SHIFT_DOWN, SHIFT_UP } from '_utils/constant'
import { getUserInfo } from '_utils/localData'
import noImage from '_images/noimage02.svg'
import InputProduct from './InputProduct'
import ProductSettingModal from './ProductSettingModal'
import SubItem from './SubItem'
import SplitCaseModal from './SplitCaseModal'
import PlanModal from '../components/PlanModal'

const OptionsPortal = ({ anchorRef, children, onClose }) => {
  const elRef = useRef(null)
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 })

  useEffect(() => {
    const el = anchorRef?.current
    if (!el) return
    const update = () => {
      const r = el.getBoundingClientRect()
      setPos({
        top: r.bottom + window.scrollY,
        left: r.left + window.scrollX,
        width: r.width,
      })
    }
    update()
    window.addEventListener('resize', update)
    window.addEventListener('scroll', update, true)
    return () => {
      window.removeEventListener('resize', update)
      window.removeEventListener('scroll', update, true)
    }
  }, [anchorRef])

  // checks both portal and anchor
  useEffect(() => {
    const onDocClick = (e) => {
      const { target } = e
      if (elRef.current && elRef.current.contains(target)) return
      if (anchorRef?.current && anchorRef.current.contains(target)) return
      onClose && onClose()
    }
    document.addEventListener('mousedown', onDocClick)
    return () => document.removeEventListener('mousedown', onDocClick)
  }, [anchorRef, onClose])

  if (typeof document === 'undefined') return null

  return createPortal(
    <div
      ref={elRef}
      style={{
        position: 'absolute',
        top: pos.top,
        left: pos.left,
        zIndex: 99999,
        background: '#fff',
        border: '1px solid #179d9a',
        borderRadius: 4,
        minWidth: 180,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      }}
    >
      {children}
    </div>,
    document.body
  )
}

const ProductItem = (props) => {
  const {
    productIndex,
    product,
    totalListProduct,
    control,
    register,
    removeProduct,
    insertProduct,
    swapProduct,
    watch,
    setValue,
    errors,
  } = props
  const {
    fields,
    remove: removeSubItem,
    insert: insertSubItem,
    append: appendSubItem,
  } = useFieldArray({
    control,
    name: `products.${productIndex}.subItems`,
  })

  const watchFieldArray = watch(`products.${productIndex}.subItems`)
  const controlledFields = fields.map((field, _index) => ({
    ...field,
    ...watchFieldArray[_index],
  }))

  const [imgFileUrl, setImgFileUrl] = useState(product?.photoUrls[0])
  // const [selected, setSelected] = useState('')
  const { addToast } = useToasts()
  const [showOptions, setShowOptions] = useState(false)
  const optionsRef = useRef(null)
  const userInfo = getUserInfo()
  const planModal = useModal()

  useEffect(() => {
    setImgFileUrl(product?.photoUrls[0])
  }, [product?.photoUrls[0], imgFileUrl])

  /* useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        optionsRef.current &&
        !optionsRef.current.contains(event.target)
      ) {
        setShowOptions(false)
      }
    }
    if (showOptions) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showOptions]) */

  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)
  const splitCaseModal = useModal();
  const [autoPaymentAfterChecked, setAutoPaymentAfterChecked] = useState(
    product?.splitCasePurchase?.acknowledgementRequiredPayAfter || false
  )

  const onUserImageUploaded = async (event) => {
    const { files } = event.target
    if (files) {
      const img = files[0]
      if (img) {
        const { msgResp } = await uploadApi.uploadPhoto(files)
        setImgFileUrl(URL.createObjectURL(img))
        setValue(`products.${productIndex}.photoUrls`, [msgResp.url])
      } else {
        setImgFileUrl('')
        setValue(`products.${productIndex}.photoUrls`, [])
      }
    }
  }
  const handleDescriptionChange = (e) => {
    let { value } = e.target;
    value = value.replace(/\n{3,}/g, '\n');
    setValue(`products.${productIndex}.description`, value);
  };

  const removeImage = () => {
    setImgFileUrl('')
    setValue(`products.${productIndex}.photoUrls`, [])
  }

  const handleChangeSequence = (index, direction) => {
    if (index - 1 >= 0 && direction === SHIFT_UP) {
      swapProduct(index, index - 1)
    }
    if (index + 1 < totalListProduct && direction === SHIFT_DOWN) {
      swapProduct(index, index + 1)
    }
  }
  const handleSplitCaseOk = () => {
    splitCaseModal.toggleModal()
  }

  const handleSelectChange = (e) => {
    const { value } = e.target
    switch (value) {
      case 'add-sub-items':
        appendSubItem(JSON.parse(JSON.stringify({ ...DEFAULT_SUB_ITEM })))
        break
      case 'order-config':
        toggle()
        break
      case 'split-case': {
        // if (!userInfo?.isUsingSubscription) {
        //   planModal.toggleModal()
        //   break
        // }
        const price = product?.price
        if (!price || isNaN(price) || Number(price) <= 0) {
          addToast('Please enter a valid Price before enabling Split Case Purchase!', {
            appearance: 'error',
            autoDismiss: true,
          })
          break
        }
        splitCaseModal.toggleModal()
        break
      }
      default:
        break
    }
  }
  const handleOptionClick = (value) => {
    handleSelectChange({ target: { value } })
    setShowOptions(false)
  }
  return (
    <div style={{ position: 'relative', zIndex: 998 }}>
      <div className='detail-list-news__item detail-list-news__item--background'>
        <div className='c-form'>
          <div className='row' style={{ flexWrap: 'nowrap' }}>
            <label className='col-sm-3 col-2 align-self-center'>Item Image</label>
            <div
              className='c-form upload-image-square mt-3 mb-3'
              style={{ position: 'relative', width: '140px' }}
            >
              <div className='upload-image'>
                <img src={imgFileUrl || noImage} alt='' style={{ width: 80 }} />
                <div className='upload-image-txt mt-3'>
                  <span className='mt-3'>Upload Image</span>
                </div>
                <div className='u-file-upload__item'>
                  <div className='u-file-upload__wrap'>
                    <a className='c-upload preview-images-zone'>
                      <input
                        value={''}
                        type='file'
                        accept='image/*'
                        className='inputFile'
                        onChange={onUserImageUploaded}
                      />
                    </a>
                  </div>
                </div>
              </div>
              {imgFileUrl ? <div className='button-cross' onClick={removeImage}></div> : null}
            </div>
          </div>

          <div className='row mt-0'>
            <label className='col-sm-3 col-2 align-self-center'>Item name</label>
            <div className='col-sm-9 col-10'>
              {Boolean(product.splitCasePurchase?.itemsPerCase) && (
                <span className='c-txt-org' style={{ fontSize: '14px' }}>
                  {product.splitCasePurchase.itemsPerCase} per case/carton
                </span>
              )}
              <InputProduct
                register={register(`products.${productIndex}.name`)}
                className={`form-control ${
                  errors?.products &&
                  Object.entries(errors?.products).length !== 0 &&
                  errors?.products?.[productIndex]?.name &&
                  'is-error'
                }`}
                error={errors?.products?.[productIndex]?.name?.message}
              />
            </div>
          </div>
          <div className='row'>
            <label className='col-sm-3 col-2 align-self-center'>Description</label>
            <div className='col-sm-9 col-10'>
              <textarea
                className={`form-control custom-scrollbar ${
                  errors?.products &&
                  Object.entries(errors?.products).length !== 0 &&
                  errors?.products[productIndex]?.description &&
                  'is-error'
                }`}
                rows={3}
                placeholder='(Optional)'
                {...register(`products.${productIndex}.description`)}
                onChange={handleDescriptionChange}
              />
            </div>
          </div>
          <div className='row row-price'>
            <label className='col-sm-3 col-2 align-self-start'>Price ($)</label>
            <div className='col-sm-9 col-10'>
              <InputProduct
                type='number'
                className={`form-control ${
                  errors?.products &&
                  Object.entries(errors?.products).length !== 0 &&
                  errors?.products[productIndex]?.price &&
                  'is-error'
                }`}
                register={register(`products.${productIndex}.price`)}
                step='0.01'
                error={errors?.products?.[productIndex]?.price?.message}
              />
              <div style={{ position: 'relative', maxWidth: 200 }}>
                <span
                  ref={optionsRef}
                  className='add-options-text'
                  style={{
                    display: 'inline-block',
                    color: '#179D9A',
                    fontSize: '17px',
                    cursor: 'pointer',
                    background: 'transparent',
                    marginTop: 8,
                    marginBottom: 8,
                    userSelect: 'none',
                    padding: 0,
                    border: 'none',
                    borderRadius: 0,
                  }}
                  onClick={() => setShowOptions((v) => !v)}
                >
                  Add Options
                </span>
                {showOptions && (
                  <OptionsPortal anchorRef={optionsRef} onClose={() => setShowOptions(false)}>
                    {[
                      { key: 'order-config', label: 'Order Configuration' },
                      userInfo.isUsingFeature && { key: 'split-case', label: 'Split Case Purchase' },
                      { key: 'add-sub-items', label: 'Add sub-items' },
                    ]
                      .filter(Boolean)
                      .map((opt) => (
                        <div
                          key={opt.key}
                          style={{
                            padding: '8px 16px',
                            cursor: 'pointer',
                            fontSize: 14,
                            color: '#179D9A',
                            transition: 'background 0.2s, color 0.2s',
                          }}
                          onMouseDown={() => handleOptionClick(opt.key)}
                          onClick={() => handleOptionClick(opt.key)}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#e6f7f6'
                            e.currentTarget.style.color = '#0d6b68'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'transparent'
                            e.currentTarget.style.color = '#179D9A'
                          }}
                        >
                          {opt.label}
                        </div>
                      ))}
                  </OptionsPortal>
                )}
              </div>
              <div className='btn-action'>
                {/* <a className='btn-add' onClick={toggle} /> */}
                <a
                  className='btn-copy'
                  onClick={() => {
                    insertProduct(
                      parseInt(productIndex + 1, 10),
                      JSON.parse(
                        JSON.stringify({
                          ...product,
                          pid: '',
                          photoUrls: [],
                        })
                      )
                    )
                  }}
                />
                <a className='btn-remove' onClick={() => removeProduct(productIndex)} />
              </div>
            </div>
          </div>
        </div>
        <div
          className='arrow-drap arrow-drap-up'
          onClick={() => handleChangeSequence(productIndex, SHIFT_UP)}
        />
        <div
          className='arrow-drap arrow-drap-down'
          onClick={() => handleChangeSequence(productIndex, SHIFT_DOWN)}
        />
      </div>
      {controlledFields?.map((item, i) => (
        <SubItem
          key={i}
          productIndex={productIndex}
          nestIndex={i}
          subItem={item}
          {...{ control, register, removeSubItem, insertSubItem, appendSubItem, watch, errors }}
        />
      ))}
      {isOpen && (
        <ProductSettingModal
          isOpen={isOpen}
          toggle={toggle}
          register={register}
          productIndex={productIndex}
          product={product}
          setValue={setValue}
          errors={errors}
        />
      )}
      {splitCaseModal.isOpen && (
        <SplitCaseModal
          isOpen={splitCaseModal.isOpen}
          toggle={splitCaseModal.toggleModal}
          register={register}
          control={control}
          productIndex={productIndex}
          product={product}
          setValue={setValue}
          errors={errors}
          checked={autoPaymentAfterChecked}
          setChecked={setAutoPaymentAfterChecked}
          watch={watch}
          onOk={handleSplitCaseOk}
        />
      )}
      {planModal.isOpen && (
        <PlanModal
          open={planModal.isOpen}
          toggle={planModal.toggleModal}
          onClose={planModal.closeModal}
          onOpen={planModal.openModal}
        />
      )}
    </div>
  )
}

export default ProductItem
